import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const createCheckout = async (items, originUrl, customer = null, deliveryMethod = "ship") => {
  const { data } = await api.post("/payments/checkout", {
    items: items.map((l) => ({
      product_id: l.id,
      quantity: l.qty,
      shade: l.shade || null,
    })),
    origin_url: originUrl,
    customer,
    delivery_method: deliveryMethod,
  });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};

export const joinWaitlist = async (email, productId = "copper-peptide-serum-30ml") => {
  const { data } = await api.post("/waitlist", { email, product_id: productId });
  return data;
};

// ---------------- Admin ----------------
export const adminLogin = async (password) => {
  const { data } = await api.post("/admin/login", { password });
  return data;
};

const authHeader = (token) => ({ headers: { "X-Admin-Token": token } });

export const getAdminStats = async (token) => {
  const { data } = await api.get("/admin/stats", authHeader(token));
  return data;
};

export const getAdminOrders = async (token) => {
  const { data } = await api.get("/admin/orders", authHeader(token));
  return data;
};

export const getAdminPaidOrders = async (token) => {
  const { data } = await api.get("/admin/paid-orders", authHeader(token));
  return data;
};

export const getAdminSubscribers = async (token) => {
  const { data } = await api.get("/admin/subscribers", authHeader(token));
  return data;
};

export const getAdminWaitlist = async (token) => {
  const { data } = await api.get("/admin/waitlist", authHeader(token));
  return data;
};

export const notifyWaitlist = async (token) => {
  const { data } = await api.post("/admin/waitlist/notify", {}, authHeader(token));
  return data;
};

export const getAdminProducts = async (token) => {
  const { data } = await api.get("/admin/products", authHeader(token));
  return data;
};

export const createAdminProduct = async (token, product) => {
  const { data } = await api.post("/admin/products", product, authHeader(token));
  return data;
};

export const deleteAdminProduct = async (token, productId) => {
  const { data } = await api.delete(`/admin/products/${productId}`, authHeader(token));
  return data;
};

export const createPaymentLink = async (token, sessionId) => {
  const { data } = await api.post(`/admin/orders/${sessionId}/payment-link`, {}, authHeader(token));
  return data;
};
